import { createFeature, createReducer, on } from "@ngrx/store";

import { TErrorResponse } from "@app/core/types/response.type";

import { TCoverageItem, TPolicy } from "../types/policy.type";
import { PolicyActions } from "./policy.actions";

export type TCoi = {
  errors: TErrorResponse | null;
  isLoadingFile: boolean;
};

export type TPolicyState = {
  policy: TPolicy | null;
  coverages: TCoverageItem[] | undefined;
  errors: TErrorResponse | null;
  loadingPolicy: boolean;
  coi: TCoi;
};

const initialState: TPolicyState = {
  policy: null,
  coverages: undefined,
  errors: null,
  loadingPolicy: false,
  coi: {
    errors: null,
    isLoadingFile: false,
  }
};

export const policyFeature = createFeature({
  name: "policyState",
  reducer: createReducer(
    initialState,

    on(PolicyActions.getPolicy, state => ({
      ...state,
      loadingPolicy: true,
      errors: null,
    })),

    on(PolicyActions.getPolicySuccess, (state, { policy }) => ({
      ...state,
      policy,
      loadingPolicy: false,
      errors: null,
    })),

    on(PolicyActions.getPolicyFailure, (state, { errors }) => ({
      ...state,
      loadingPolicy: false,
      errors,
    })),

    on(PolicyActions.exportAllCOI, state => ({
      ...state,
      isLoadingFile: true,
      errors: null,
    })),

    on(PolicyActions.exportOneCOI, state => ({
    ...state,
    isLoadingFile: true,
    errors: null,
    })),

    on(PolicyActions.exportCOISuccess, (state) => ({
      ...state,
      isLoadingFile: false,
      errors: null,
    })),

    on(PolicyActions.exportCOIFailure, (state, { errors }) => ({
      ...state,
      isLoadingFile: false,
      errors,
    })),
  
    on(PolicyActions.exportBatchCOI, state => ({
      ...state,
      isLoadingFile: true,
      errors: null,
    })),

    on(PolicyActions.exportCOISuccess, (state) => ({
      ...state,
      isLoadingFile: false,
      errors: null,
    })),

    on(PolicyActions.exportCOIFailure, (state, { errors }) => ({
      ...state,
      isLoadingFile: false,
      errors,
    })),

    on(PolicyActions.setCoverages, (state, { coverages }) => ({
      ...state,
      coverages
    })),
    ),
});
